module.exports = __webpack_public_path__ + "img/left-side-menu-select-active.253c6fe1.svg";